import React from 'react'
import InlinePreloader from './InlinePreloader'

const ModalActionButton = ({buttonLabel, buttonAction, processing}) => {
  return (
    <button
        disabled={processing} 
        type="button"
        className="inline-flex justify-center font-space-grotesk px-5 py-4 text-sm font-medium bg-primary text-white border border-transparent rounded-xl hover:bg-opacity-90 transition duration-200 focus:outline-none w-full"
        onClick={()=>{buttonAction()}}
    >
        {processing ? <InlinePreloader /> : buttonLabel}
    </button>
  )
}

export default ModalActionButton